import type { PlaybookCriterionNode } from "@repo/app-types/entities/playbook";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { SimpleSelect } from "@repo/ui/Select/simpleSelect";
import type { FC } from "react";
import { DiffableField } from "../diffableField.js";

const gradingTypeOptions = [
  { value: "yes_no" as const, label: "Yes/No" },
  { value: "1_5_score" as const, label: "1-5 Score" },
];

export interface CriteriaFormProps {
  criteria: PlaybookCriterionNode;
  liveCriteria?: PlaybookCriterionNode;
  onUpdateCriterion: (updates: Partial<PlaybookCriterionNode>) => void;
  isReadOnly?: boolean;
}

export const CriteriaForm: FC<CriteriaFormProps> = ({
  criteria,
  liveCriteria,
  onUpdateCriterion,
  isReadOnly = false,
}) => {
  const currentGradingContext = criteria.grading_context ?? "";

  return (
    <div className="flex min-h-0 flex-1 flex-col space-y-4">
      <div>
        <DiffableField
          label={<Label size={Size.SMALL}>Name</Label>}
          originalValue={liveCriteria?.name}
          value={criteria.name}
          onChange={(name) => {
            onUpdateCriterion({ name });
          }}
          placeholder="Read compliance disclaimer in the first 2 minutes"
          isReadOnly={isReadOnly}
          maxLength={300}
          variant="input"
        />
      </div>

      <div className="flex gap-3">
        <div>
          <SimpleSelect
            label="Grading type"
            options={gradingTypeOptions}
            value={criteria.grading_value_type}
            onChange={(value) => {
              onUpdateCriterion({ grading_value_type: value });
            }}
            isDisabled={isReadOnly}
            placeholder="Select grading type..."
          />
        </div>
      </div>

      <div className="flex min-h-0 flex-1 flex-col">
        <DiffableField
          label={<Label size={Size.SMALL}>Grading context</Label>}
          originalValue={
            liveCriteria ? (liveCriteria.grading_context ?? "") : undefined
          }
          value={currentGradingContext}
          onChange={(value) => {
            onUpdateCriterion({ grading_context: value });
          }}
          placeholder="Add context that the AI grader should use..."
          maxLength={11000}
          isReadOnly={isReadOnly}
          isMarkdown
          hasDiffMinimap
          editorClassName="min-h-0 flex-1"
        />
      </div>
    </div>
  );
};
